<template>
    <form @submit.prevent="submitForm">
        <div class="max-w-4xl mx-auto">
            <template v-if="! submitted">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <p class="mt-1 text-red-600"
                         v-if="hasError('checksum')"
                    >
                        {{ getErrorFor('checksum') }}
                    </p>

                    <form-input v-model="form.name"
                                label="Name"
                                :required="true"
                                :error="getErrorFor('name')"
                                class="sm:col-span-2"
                    ></form-input>

                    <form-input v-model="form.email"
                                type="email"
                                label="Email"
                                :required="true"
                                :error="getErrorFor('email')"
                    ></form-input>

                    <form-input v-model="form.phone"
                                type="number"
                                label="Phone Number"
                                :error="getErrorFor('phone')"
                    ></form-input>

                    <form-textarea v-model="form.message"
                                   label="Message"
                                   :rows="8"
                                   :required="true"
                                   :error="getErrorFor('message')"
                                   class="sm:col-span-2"
                    ></form-textarea>
                </div>

                <div class="flex justify-end">
                    <form-button type="submit">Submit</form-button>
                </div>
            </template>

            <div class="Copy"
                 v-else
            >
                <div v-html="successMessage"
                     v-if="successMessage"
                >
                </div>

                <div v-else>
                    <p class="text-center">
                        Thank you, your enquiry has been submitted. We will contact you shortly for payment and delivery details.
                    </p>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import FormInput from "../form/Input";
    import FormTextarea from "../form/Textarea";
    import FormButton from "../form/public/Button";

    import Form from "../../mixins/Form";

	export default {
	    data() {
	        return {
	            form: {
	                subject: '',
                    checksum: '',
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                },

                submitting: false,
                submitted: false,
            }
        },

		props: {
		    subject: {
		        type: String,
                required: true,
            },

            checksum: {
		        type: String,
                required: true,
            },

            successMessage: {
		        type: String,
            }
        },

        components: { FormTextarea, FormInput, FormButton },

        mixins: [Form],

        created() {
	        this.form.subject = this.subject;
	        this.form.checksum = this.checksum;
        },

        methods: {
	        submitForm() {
	            if (this.submitting) return false;

	            this.submitting = true;

	            this.post('/forms')
                    .then(() => {
                        this.submitted = true;
                        this.submitting = false;
                    })
                    .catch(() => {
                        this.submitting = false;
                    });
            }
        }
	}
</script>
